export type RotwBadgeTier = "gold" | "silver" | "bronze" | "neutral" | "transparent";

export function getRotwBadgeTier(rank: number): RotwBadgeTier {
  if (rank === 1) return "gold";
  if (rank === 2) return "silver";
  if (rank === 3) return "bronze";
  return "neutral";
}
